"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            Globalize.addCultureInfo("en", {
                messages: {
                    Input_Call: "Call",
                    Input_ContactAvailable: "Available",
                    Input_ContactAway: "Away",
                    Input_ContactBeRightBack: "Be right back",
                    Input_ContactBusy: "Busy",
                    Input_ContactDoNotDisturb: "Do not disturb",
                    Input_ContactOffline: "Offline",
                    Input_ContactUnknown: "Unknown",
                    Input_Email: "Email",
                    Input_Message: "Message",
                    Input_SkypeSignIn: "Sign in",
                },
            });
            /**
             * The ID of the first focusable element in the contact card
             * @internal
             */
            var FirstElementId = "FirstElement";
            /**
             * The ID of the last focusable element in the contact card
             * @internal
             */
            var LastElementId = "LastElement";
            var SkypeContactCard = /** @class */ (function (_super) {
                __extends(SkypeContactCard, _super);
                function SkypeContactCard(props) {
                    var _this = _super.call(this, props) || this;
                    /**
                     * Handles the keyboard event
                     * @internal
                     * @param event The keyboard event
                     */
                    _this.onCardKeyDown = function (event) {
                        if (event.altKey && event.shiftKey && event.which === $dyn.ui.KeyCodes.letterP) {
                            _this.props.ToggleQtip();
                        }
                        else if (event.which === $dyn.ui.KeyCodes.tab) {
                            var firstElement = $(_this.refs[FirstElementId]);
                            var lastElement = $(_this.refs[LastElementId]);
                            if (event.shiftKey) {
                                if (firstElement.is(":focus")) {
                                    lastElement.focus();
                                    event.stopPropagation();
                                    event.preventDefault();
                                }
                            }
                            else {
                                if (lastElement.is(":focus")) {
                                    firstElement.focus();
                                    event.stopPropagation();
                                    event.preventDefault();
                                }
                            }
                        }
                    };
                    /**
                     * Redirects to the Skype authentication page to retrieve a token
                     * @internal
                     */
                    _this.redirectForToken = function () {
                        window.location.replace($dyn.skypeInteraction.getRedirectUrl());
                    };
                    _this.state = { hasInvalidAvatarUrl: false };
                    return _this;
                }
                /**
                 * Generates a ReactElement to render to the DOM
                 * @internal
                 * @returns The ReactElement to render to the DOM
                 */
                SkypeContactCard.prototype.render = function () {
                    var _this = this;
                    var handleAvatarImageError = function () {
                        // When the avatar image fails to load, set the state so that the contact's initials are displayed instead
                        _this.setState({ hasInvalidAvatarUrl: true });
                    };
                    if (!this.props.Authenticated) {
                        return (React.createElement("div", { tabIndex: 0, className: "popupShadow layout-root-scope" },
                            React.createElement("a", { className: "skype-signInLink", href: "#", tabIndex: 0, onClick: this.redirectForToken }, $dyn.label("Input_SkypeSignIn"))));
                    }
                    else {
                        var presenceValue = this.props.PresenceValue || $dyn.skypeInteraction.PresenceType.Unknown;
                        var contactName = this.props.ContactName || this.props.SipAddress || "";
                        var pictureElement = void 0;
                        if (this.props.AvatarUrl && !this.state.hasInvalidAvatarUrl) {
                            pictureElement = (React.createElement("img", { className: "skype-contactCard-pictureDisplay", src: this.props.AvatarUrl, onError: handleAvatarImageError }));
                        }
                        else {
                            // When an avatar URL is invalid or not provided, show the contact's initials in its place
                            var initials = "";
                            var nameSplit = contactName.split(" ");
                            var firstName = nameSplit[0];
                            var lastName = nameSplit[1];
                            if (firstName && lastName) {
                                initials = firstName[0] + lastName[0];
                            }
                            else if (firstName) {
                                initials = firstName.substring(0, 2);
                            }
                            else if (lastName) {
                                initials = lastName.substring(0, 2);
                            }
                            pictureElement = (React.createElement("div", { className: "skype-contactCard-picturePlaceholder" }, initials.toUpperCase()));
                        }
                        // Build up an array of contact methods to display
                        var contactMethods = [];
                        contactMethods.push(this.createContactMethodArea("email", $dyn.label("Input_Email"), "skype-contactCard-emailIcon", false, function () {
                            window.location.replace("mailto:" + _this.props.SipAddress);
                        }));
                        contactMethods.push(this.createContactMethodArea("message", $dyn.label("Input_Message"), "skype-contactCard-messageIcon", !this.props.ContactPhone, function () {
                            window.location.replace("sip:" + _this.props.SipAddress);
                        }));
                        if (this.props.ContactPhone) {
                            contactMethods.push(this.createContactMethodArea("call", $dyn.label("Input_Call"), "skype-contactCard-callIcon", true, function () {
                                window.location.replace("tel:" + _this.props.ContactPhone);
                            }));
                        }
                        // Determine the presence label to display
                        var presenceLabel = $dyn.label("Input_ContactUnknown");
                        switch (presenceValue) {
                            case $dyn.skypeInteraction.PresenceType.Online:
                                presenceLabel = $dyn.label("Input_ContactAvailable");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Offline:
                                presenceLabel = $dyn.label("Input_ContactOffline");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Away:
                                presenceLabel = $dyn.label("Input_ContactAway");
                                break;
                            case $dyn.skypeInteraction.PresenceType.BeRightBack:
                                presenceLabel = $dyn.label("Input_ContactBeRightBack");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Busy:
                                presenceLabel = $dyn.label("Input_ContactBusy");
                                break;
                            case $dyn.skypeInteraction.PresenceType.DoNotDisturb:
                                presenceLabel = $dyn.label("Input_ContactDoNotDisturb");
                                break;
                            case $dyn.skypeInteraction.PresenceType.Unknown:
                                presenceLabel = $dyn.label("Input_ContactUnknown");
                                break;
                        }
                        return (React.createElement("div", { className: "skype-contactCard-internalCard", onKeyDown: this.onCardKeyDown },
                            React.createElement("div", { className: "skype-contactCard-pictureArea" },
                                React.createElement("div", { className: "skype-contactCard-pictureContainer" }, pictureElement),
                                React.createElement("div", { className: "skype-contactCard-pictureDecoration" },
                                    React.createElement("span", { className: "skype-contactCard-presenceIcon skype-hasPresence" + presenceValue }))),
                            React.createElement("div", { className: "skype-contactCard-detailsArea", tabIndex: -1 },
                                React.createElement("div", { className: "skype-contactCard-textArea" },
                                    React.createElement("span", { id: "contactCardName", className: "skype-contactCard-header", tabIndex: 0, ref: FirstElementId }, contactName)),
                                React.createElement("div", { className: "skype-contactCard-textArea" },
                                    React.createElement("span", { id: "contactCardStatus", className: "skype-contactCard-subHeader", tabIndex: 0 }, presenceLabel)),
                                React.createElement("div", { className: "skype-contactCard-textArea" },
                                    React.createElement("span", { id: "contactCardTitle", className: "skype-contactCard-subHeader", tabIndex: 0 }, this.props.ContactTitle || "")),
                                React.createElement("div", { className: "skype-contactCard-contactArea" }, contactMethods))));
                    }
                };
                /**
                 * Generate a ReactElement representing a contact method button
                 * @internal
                 * @param name The name of the contact method, used to key each element in the DOM
                 * @param label The label to attach to the button
                 * @param iconClass The name of the CSS class used to style the button's iconClass
                 * @param isLastElement Indicates whether this is the last element in the contact card
                 * @param clickHandler The function to bind as the button's click handler
                 * @returns The ReactElement representing the contact method button
                 */
                SkypeContactCard.prototype.createContactMethodArea = function (name, label, iconClass, isLastElement, clickHandler) {
                    var iconClasses = "skype-contactCard-contactIcon " + iconClass;
                    var uid = Date.now();
                    return (React.createElement("div", { key: name + "Area" + uid, className: "skype-contactCard-contactMethodArea" },
                        React.createElement("button", { id: name + "Button", key: name + "Button" + uid, className: "skype-contactCard-contactButton", onClick: clickHandler, tabIndex: 0, title: label, type: "button", ref: isLastElement ? LastElementId : null },
                            React.createElement("span", { key: name + "Icon" + uid, className: iconClasses }))));
                };
                return SkypeContactCard;
            }(React.Component));
            UI.SkypeContactCard = SkypeContactCard;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SkypeContactCard.js.map
